export default class Purchase {

    constructor(object, template) {
        this.object = object;
        this.clone = template.content.cloneNode(true);
    }

    element() {
        let modal_body = this.clone.querySelector('.tvod-content');
        if ( modal_body ) {
            let cover_art = modal_body.querySelector('.tvod-cover-art');
            cover_art.setAttribute('src', this.object.coverArt() );

            let name = modal_body.querySelector('.tvod-name');
            name.innerHTML = this.object.name();

            let series_name = modal_body.querySelector('.tvod-series-name');
            series_name.innerHTML = this.object.seriesName();

            let transactions= ['rent', 'buy'];
            for( let i in transactions ) {
                let purchase_amount = this.object.data['purchase'][transactions[i]];
                let amount = modal_body.querySelector('.tvod-' + transactions[i] + '-amount');
                amount.innerHTML = purchase_amount;
            }

            let form = modal_body.querySelector( '#new_movie_0' );
            form.action = this.object.tvodUrl();

            return modal_body;
        }

        return null;
    }

}